import L from 'leaflet'
import { getImageBlob } from './tileManager'

type DoneCallback = (error?: Error, tile?: HTMLElement) => void

export class CustomTileLayer extends L.TileLayer {
  constructor(urlTemplate: string, options?: L.TileLayerOptions) {
    super(urlTemplate, {
      maxZoom: 22,
      maxNativeZoom: 17,
      ...options
    })
  }

  override createTile(coords: L.Coords, done: DoneCallback): HTMLElement {
    const tile = document.createElement('img')
    const zoom = coords.z > 18 ? 18 : coords.z
    tile.innerHTML = [coords.x, coords.y, coords.z].join(', ')
    const key = `https://cyberjapandata.gsi.go.jp/xyz/std/${zoom}/${coords.x}/${coords.y}.png`
    getImageBlob(key)
      .then(data => {
        if (data) {
          // デバック用 オフライン画像タイルをハイライトする
          // tile.style.outline = '3px solid red'
          const url = URL.createObjectURL(data)
          tile.src = url
          tile.height = 256
          tile.width = 256
          tile.onload = () => {
            done(undefined, tile)
          }
          tile.onerror = err =>
            done(err instanceof Error ? err : new Error('Tile load error'), tile)
        }
      })
      .catch(e => {
        console.error(e)
      })

    return tile
  }
}
